import api, { unwrap, unwrapList } from './api';
import type {
  AdminCompany, AdminCompanyDetail, AdminStationRow, AdminEmployeeRow, AdminCompanyOverview,
  AdminCompanyCreateResult, CreateCompanyPayload, UpdateTrialPayload,
} from '../types';

export const companiesService = {
  list: (params: { search?: string; status?: string }) =>
    api.get('admin/companies', { params }).then((r) => unwrapList<AdminCompany>(r).data),
  get: (id: string) => api.get(`admin/companies/${id}`).then(unwrap<AdminCompanyDetail>),
  suspend: (id: string, reason: string) => api.post(`admin/companies/${id}/suspend`, { reason }).then(unwrap<AdminCompanyDetail>),
  reactivate: (id: string) => api.post(`admin/companies/${id}/reactivate`).then(unwrap<AdminCompanyDetail>),
  stations: (id: string) => api.get(`admin/companies/${id}/stations`).then(unwrap<AdminStationRow[]>),
  usersOf: (id: string, params: { search?: string; page?: number } = {}) =>
    api.get(`admin/companies/${id}/users`, { params }).then((r) => unwrapList<AdminEmployeeRow>(r)),
  overview: (id: string) => api.get(`admin/companies/${id}/overview`).then(unwrap<AdminCompanyOverview>),
  create: (body: CreateCompanyPayload) => api.post('admin/companies', body).then(unwrap<AdminCompanyCreateResult>),
  updateTrial: (id: string, body: UpdateTrialPayload) =>
    api.put(`admin/companies/${id}/trial`, body).then(unwrap<AdminCompanyDetail>),
};
